<template>
  <div class="theme-transition overflow-hidden" :data-theme="theme">
    <!-- 移动端顶部导航 -->
    <div class="lg:hidden fixed top-0 left-0 w-full z-[60] px-4 py-3 bg-[#09090b]/95 backdrop-blur-md border-b border-white/5 flex items-center gap-3 transition-all duration-300 shadow-lg">
      <button @click="toggleMobileMenu" class="flex-shrink-0 w-10 h-10 flex items-center justify-center text-gray-400 hover:text-white active:scale-95 transition-all">
        <i class="fas fa-bars text-xl"></i>
      </button>
      <div class="flex-1 flex p-1 bg-white/5 rounded-full border border-white/5">
        <button 
          @click="switchToCreate"
          :class="['flex-1 py-1.5 text-xs font-bold rounded-full shadow-sm transition-all duration-300 flex items-center justify-center gap-1', 
            activeTab === 'create' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:text-gray-200']">
          <i class="fas fa-paint-brush text-[10px]"></i> 创作
        </button>
        <button 
          @click="switchToInspire"
          :class="['flex-1 py-1.5 text-xs font-medium rounded-full transition-all duration-300 flex items-center justify-center gap-1',
            activeTab === 'inspire' ? 'bg-blue-600 text-white' : 'text-gray-400 hover:text-gray-200']">
          <i class="fas fa-fire text-[10px]"></i> 灵感
        </button>
      </div>
    </div>

    <!-- 遮罩层 -->
    <div v-if="showMobileMenu" @click="closeMobileMenu" class="fixed inset-0 bg-black/50 z-[90] backdrop-blur-sm transition-opacity"></div>

    <!-- 主容器 -->
    <div id="main-container" class="flex flex-col lg:flex-row h-screen w-full overflow-hidden mobile-scroll-fix pt-[92px] lg:pt-0 lg:ml-20">
      <!-- 左侧菜单 -->
      <div :class="['side-nav-container w-20 component-bg flex flex-col items-center py-8 border-r border-custom theme-transition h-full fixed top-0 left-0 z-50 transition-transform duration-300 flex-shrink-0 shadow-2xl',
        showMobileMenu ? 'translate-x-0' : '-translate-x-full lg:translate-x-0']">
        <button @click="closeMobileMenu" class="lg:hidden mb-6 w-8 h-8 rounded-full bg-gray-700 text-gray-300 flex items-center justify-center">
          <i class="fas fa-times"></i>
        </button>
        <div class="mb-6 text-2xl text-transparent bg-clip-text bg-gradient-to-br from-blue-400 to-purple-600">
          <i class="fas fa-rocket"></i>
        </div>
        <div class="flex flex-col items-center space-y-4 w-full">
          <button @click="showRechargeCenter" class="w-10 h-10 rounded-lg flex items-center justify-center text-yellow-500 hover:text-yellow-400 transition-colors relative bg-yellow-500/10">
            <i class="fas fa-bolt text-xl"></i>
            <span class="absolute -top-1 -right-1 w-2 h-2 bg-orange-500 rounded-full"></span>
          </button>
          <button @click="showNotification" class="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-blue-500 transition-colors">
            <i class="fas fa-bell text-xl"></i>
          </button>
          <!-- <a href="https://api.fengjungpt.com" target="_blank" class="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-blue-500 transition-colors font-bold text-xs no-underline">API</a> -->
          <button @click="showTutorial" class="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-blue-500 transition-colors">
            <i class="fas fa-book-open text-base"></i>
          </button>
          <button
            @click="$router.push('/creative-hub')"
            class="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-fuchsia-400 transition-colors"
            title="创作中心"
          >
            <i class="fas fa-wand-magic-sparkles text-base"></i>
          </button>
          <button
            @click="$router.push('/projects')"
            class="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-emerald-400 transition-colors"
            title="我的项目"
          >
            <i class="fas fa-grid-2 text-base"></i>
          </button>
          <router-link
            to="/assets"
            class="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-fuchsia-400 transition-colors"
            title="我的资产"
          >
            <i class="fas fa-boxes-stacked text-base"></i>
          </router-link>
          <button
            @click="$router.push('/video-copy')"
            class="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-blue-500 transition-colors"
            title="视频文案提取"
          >
            <i class="fas fa-video text-base"></i>
          </button>
          <button
            @click="$router.push('/director-deck')"
            class="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-violet-400 transition-colors"
            title="3D 导演台"
          >
            <i class="fas fa-clapperboard text-base"></i>
          </button>
          <button @click="toggleTheme" class="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-blue-500 transition-colors">
            <i :class="['fas', theme === 'light' ? 'fa-sun text-orange-500' : 'fa-moon text-xl']"></i>
          </button>
        </div>
        <div class="relative mt-auto pt-6 border-t border-custom w-full flex justify-center">
          <button @click="toggleUserMenu" class="w-10 h-10 rounded-full overflow-hidden border-2 border-transparent hover:border-blue-500 transition-all">
            <div class="w-full h-full bg-gray-700 flex items-center justify-center">
              <i class="fas fa-user text-white"></i>
            </div>
          </button>
          <div v-if="showUserMenu" class="absolute bottom-0 left-16 mb-2 w-36 rounded-lg component-tertiary shadow-xl z-50 overflow-hidden">
            <button @click="openUserCenter" class="w-full px-4 py-3 text-xs text-left hover:bg-blue-500/10 text-blue-400">
              <i class="fas fa-id-card mr-2"></i>个人中心
            </button>
            <button @click="handleLogout" class="w-full px-4 py-3 text-xs text-left hover:bg-red-500/10 text-red-400 border-t border-custom">
              <i class="fas fa-sign-out-alt mr-2"></i>退出
            </button>
          </div>
        </div>
      </div>

      <!-- 中间：创作页 -->
      <div :class="['w-full lg:w-96 h-full component-bg border-r border-custom flex flex-col theme-transition control-panel relative z-10 flex-shrink-0 shadow-xl',
        activeTab === 'create' ? 'flex' : 'hidden lg:flex']">
        <div class="p-6 space-y-6 overflow-y-auto flex-1 scrollbar-none flex flex-col">
          <div class="flex items-center justify-between mobile-header-container pl-12 lg:pl-0 flex-shrink-0">
            <div>
              <h1 class="text-xl font-extrabold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">Nano Banana</h1>
              <p class="text-[10px] text-gray-500 tracking-widest uppercase">AI Creative Studio</p>
            </div>
            <span class="text-[10px] px-2 py-1 rounded-full bg-green-500/10 text-green-500 border border-green-500/20 flex items-center gap-1">
              <span class="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>在线
            </span>
          </div>

          <div class="flex-shrink-0">
            <label class="text-xs font-bold text-gray-500 mb-2 block uppercase pl-1">AI Model</label>
            <div class="relative">
              <button @click="toggleModelDropdown" class="w-full component-tertiary rounded-xl px-4 py-3 flex items-center justify-between hover:border-blue-500/50 transition-all text-left">
                <div class="flex items-center space-x-3">
                  <span class="text-2xl">{{ selectedModelInfo.icon }}</span>
                  <span class="font-medium text-sm">{{ selectedModelInfo.name }}</span>
                </div>
                <i class="fas fa-chevron-down text-xs text-gray-400"></i>
              </button>
              <div v-if="showModelDropdown" class="absolute top-full left-0 right-0 mt-2 component-tertiary rounded-xl shadow-2xl z-30 overflow-hidden p-1">
                <div class="p-1 space-y-1">
                  <button 
                    v-for="model in models" 
                    :key="model.id"
                    @click="selectModel(model)"
                    class="w-full text-left px-3 py-3 rounded-lg flex items-center space-x-3 hover:bg-blue-500/10 group transition-colors">
                    <span class="text-2xl group-hover:scale-110 transition-transform">{{ model.icon }}</span>
                    <div>
                      <div class="font-bold text-sm group-hover:text-blue-500 transition-colors">{{ model.name }}</div>
                      <div class="text-[10px] text-gray-400 group-hover:text-blue-400/70">{{ model.description }}</div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 参考图上传区域 -->
          <div class="p-3 lg:p-4 rounded-xl border border-dashed border-custom bg-opacity-50 hover:border-blue-500/50 transition-all flex-shrink-0">
            <div class="flex items-center justify-between mb-2">
              <label class="text-[10px] lg:text-xs font-bold text-gray-500 flex items-center gap-2">
                <i class="fas fa-image text-blue-500"></i> 参考图
              </label>
              <span class="text-[10px] px-2 py-0.5 rounded bg-blue-500/10 text-blue-500">Max 3</span>
            </div>
            <div v-if="uploadedImageFiles.length > 0" class="mb-2">
              <div class="grid grid-cols-3 gap-2 mb-2">
                <div v-for="(file, index) in uploadedImageFiles" :key="file._uploadId" class="relative group rounded-lg overflow-hidden cursor-pointer">
                  <img :src="getImagePreview(file)" class="w-full h-20 object-cover">
                  <div class="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all flex items-center justify-center">
                    <button @click="removeUploadedImage(index)" class="text-white bg-red-500 rounded-full w-6 h-6 flex items-center justify-center hidden group-hover:flex">
                      <i class="fas fa-times text-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
              <p class="text-[10px] text-gray-500 text-center">已上传 {{ uploadedImageFiles.length }}/3</p>
            </div>
            <button 
              v-if="uploadedImageFiles.length < 3"
              @click="handleImageUpload" 
              class="w-full h-8 lg:h-10 rounded-lg bg-opacity-50 hover:bg-blue-500/10 text-gray-500 hover:text-blue-500 text-[10px] lg:text-xs flex items-center justify-center gap-2 transition-all border border-transparent">
              <i class="fas fa-plus"></i> <span>上传</span>
            </button>
          </div>

          <!-- Prompt 输入区域 -->
          <div class="flex-shrink-0 flex flex-col mt-2 lg:mt-0" style="height: 140px;">
            <label class="text-[10px] lg:text-xs font-bold text-gray-500 mb-1 lg:mb-2 block uppercase pl-1 flex justify-between">
              <span>Prompt</span>
              <span @click="clearPrompt" class="text-blue-500 cursor-pointer">清空</span>
            </label>
            <div class="relative flex-1 w-full h-full">
              <textarea 
                v-model="prompt"
                @input="updateCharCount"
                class="w-full h-full component-tertiary rounded-xl p-3 resize-none text-xs lg:text-sm leading-relaxed focus:outline-none" 
                style="background-color: var(--bg-tertiary) !important;" 
                placeholder="描述你想生成的画面..." 
                maxlength="2000"></textarea>
              <div class="absolute bottom-2 right-3 text-[10px] text-gray-500">{{ charCount }}/2000</div>
            </div>
          </div>

          <!-- 高级设置 -->
          <div class="flex-shrink-0 pb-4">
            <button @click="toggleAdvanced" class="w-full flex items-center justify-between text-xs font-medium text-gray-500 hover:text-blue-500 py-2">
              <span><i class="fas fa-sliders-h mr-1"></i> 高级设置</span>
              <i :class="['fas fa-chevron-right text-[10px] transition-transform', showAdvanced ? 'rotate-90' : '']"></i>
            </button>
            <div v-if="showAdvanced" class="mt-3 space-y-4 pl-1">
              <div>
                <label class="text-[10px] text-gray-500 mb-1 block">生成数量</label>
                <select v-model="selectedQuantity" class="w-full component-tertiary rounded-lg px-3 py-2 text-xs outline-none cursor-pointer">
                  <option value="1">1 张</option>
                  <option value="2">2 张</option>
                  <option value="3">3 张</option>
                  <option value="4">4 张</option>
                </select>
              </div>
              <div v-if="selectedModel.startsWith('nano-banana-2')" class="transition-all duration-300">
                <label class="text-[10px] text-gray-500 mb-1 block flex items-center gap-1">
                  画面比例 <span class="text-blue-500 text-[9px] border border-blue-500/30 px-1 rounded">2.0 模型专属</span>
                </label>
                <select v-model="aspectRatio" class="w-full component-tertiary rounded-lg px-3 py-2 text-xs outline-none cursor-pointer">
                  <option value="1:1">1:1 (正方形)</option>
                  <option value="3:4">3:4 (手机竖屏)</option>
                  <option value="4:3">4:3 (iPad/老照片)</option>
                  <option value="16:9">16:9 (电脑横屏)</option>
                  <option value="9:16">9:16 (抖音/全屏)</option>
                  <option value="21:9">21:9 (电影宽屏)</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- 生成按钮区域 -->
        <div class="p-6 component-bg flex-shrink-0" style="border-top: 1px solid var(--border-color);">
          <button 
            @click="handleGenerate" 
            :disabled="isGenerating"
            class="w-full py-4 px-6 text-white font-bold rounded-xl flex items-center justify-center gap-3 group relative overflow-hidden transition-transform active:scale-95"
            :class="{'opacity-50 cursor-not-allowed': isGenerating}"
            style="background: var(--btn-gradient); background-size: 200% 200%; box-shadow: var(--shadow-glow); border: none; animation: gradientMove 3s ease infinite;">
            <span v-if="!isGenerating">立即生成</span>
            <span v-else><i class="fas fa-spinner fa-spin mr-2"></i>处理中...</span>
            <i v-if="!isGenerating" class="fas fa-gem text-lg animate-pulse"></i>
          </button>
          <p class="text-[10px] text-gray-500 text-center mt-3">
            <i class="fas fa-bolt text-yellow-500 mr-1"></i> 预计耗时 10-30 秒
          </p>
        </div>
      </div>

      <!-- 右侧：灵感页 -->
      <div :class="['flex-1 theme-transition flex flex-col lg:h-screen relative overflow-hidden z-10',
        activeTab === 'inspire' ? 'flex' : 'hidden lg:flex']">
        <div class="p-6 border-b border-custom backdrop-blur-md flex items-center justify-between flex-shrink-0">
          <div class="flex rounded-full p-1 border border-custom component-tertiary">
            <button 
              @click="switchToInspirationTab"
              :class="['px-4 lg:px-6 py-2 rounded-full text-xs font-bold transition-all flex items-center gap-2',
                currentView === 'inspiration' ? 'bg-blue-500/10 text-blue-500' : 'text-gray-500 hover:text-blue-500']">
              <i class="fas fa-fire"></i> 灵感
            </button>
            <button 
              @click="switchToMyWorksTab"
              :class="['px-4 lg:px-6 py-2 rounded-full text-xs font-bold transition-all flex items-center gap-2',
                currentView === 'myworks' ? 'bg-blue-500/10 text-blue-500' : 'text-gray-500 hover:text-blue-500']">
              <i class="fas fa-folder-open"></i> 我的
            </button>
          </div>
          <div class="hidden sm:flex relative">
            <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-xs"></i>
            <input type="text" placeholder="搜索..." class="pl-8 pr-4 py-1.5 rounded-full text-xs component-tertiary w-40 focus:w-56 transition-all">
          </div>
        </div>

        <div class="flex-1 overflow-y-auto p-6 lg:p-10 scrollbar-thin pb-24 lg:pb-10">
          <h2 class="text-xl font-bold mb-6">{{ currentView === 'inspiration' ? '创意灵感库' : '我的创作历史' }}</h2>
          <div class="masonry-grid w-full pb-20" id="inspirationContainer">
            <div v-if="loading" class="text-center text-gray-500 text-xs w-full py-10">
              <i class="fas fa-circle-notch fa-spin mr-2"></i> 正在加载...
            </div>
            <div v-else-if="currentView === 'inspiration' && inspirations.length === 0" class="text-center text-gray-500 text-xs w-full py-10">
              <i class="fas fa-info-circle mr-2"></i> 暂无灵感数据
            </div>
            <div v-else-if="currentView === 'myworks' && myWorks.length === 0" class="text-center text-gray-500 text-xs w-full py-10">
              你还没有生成过图片，快去创作吧！
            </div>
            <template v-else>
              <div 
                v-for="item in displayItems" 
                :key="item.id || item._id"
                @click="handleItemClick(item)"
                :class="['masonry-item group cursor-pointer animate-[fadeIn_0.5s_ease-out]', 
                  currentView === 'inspiration' ? 'cursor-pointer' : '']">
                <div class="component-tertiary rounded-xl overflow-hidden hover:ring-2 hover:ring-blue-500/50 transition-all duration-300 shadow-lg border border-white/5 flex flex-col h-full bg-[#1e1e1e]">
                  <div class="relative w-full bg-gray-900/50 group/image overflow-hidden" :style="getAspectRatioStyle(item)">
                    <img :src="fixImageUrl(item.url || item.image_url)" alt="AI Image" class="w-full h-full object-contain transition-transform duration-700 group-hover/image:scale-105" loading="lazy">
                    <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover/image:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
                  </div>
                  <div class="p-4 flex flex-col flex-1 gap-3">
                    <h3 class="font-medium text-gray-300 text-xs leading-relaxed line-clamp-2 min-h-[2.5em] select-none" :title="item.prompt || ''">
                      {{ item.prompt || '无标题' }}
                    </h3>
                    <div class="h-px w-full bg-white/5"></div>
                    <div v-if="currentView === 'inspiration'" class="mt-3 flex items-center gap-2 text-[10px] text-blue-400 font-bold uppercase tracking-wider">
                      <i class="fas fa-magic animate-pulse"></i> <span>点击应用提示词</span>
                    </div>
                    <div v-else class="flex items-center justify-between">
                      <div class="flex items-center gap-2">
                        <button @click.stop="downloadImage(item.url || item.image_url, item.prompt)" class="w-8 h-8 rounded-lg bg-white/5 hover:bg-blue-600 hover:text-white text-gray-400 transition-all flex items-center justify-center" title="下载原图">
                          <i class="fas fa-download text-xs"></i>
                        </button>
                        <button @click.stop="useAsReference(item.url || item.image_url)" class="w-8 h-8 rounded-lg bg-white/5 hover:bg-purple-600 hover:text-white text-gray-400 transition-all flex items-center justify-center" title="作为参考图">
                          <i class="fas fa-magic text-xs"></i>
                        </button>
                      </div>
                      <button @click.stop="deleteImage(item.id || item._id)" class="w-8 h-8 rounded-lg hover:bg-red-500/20 hover:text-red-400 text-gray-600 transition-all flex items-center justify-center" title="删除这张图">
                        <i class="fas fa-trash-alt text-xs"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- 用户中心弹窗 -->
    <div v-if="showUserCenterModal" @click.self="closeUserCenter" class="fixed inset-0 z-[70] flex items-center justify-center">
      <div class="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
      <div class="relative component-bg w-full max-w-md mx-4 rounded-2xl shadow-2xl overflow-hidden" @click.stop>
        <div class="h-24 bg-gradient-to-r from-blue-500 to-purple-600 relative">
          <button @click="closeUserCenter" class="absolute top-3 right-3 text-white text-xl w-8 h-8 flex items-center justify-center hover:bg-white/20 rounded-full transition-colors">×</button>
        </div>
        <div class="px-6 pb-6 relative">
          <div class="w-20 h-20 rounded-full bg-gray-900 border-4 border-[#1e1e24] -mt-10 mb-4 flex items-center justify-center shadow-lg overflow-hidden">
            <img v-if="userInfo.headimg" :src="userInfo.headimg" :alt="userInfo.name || '用户头像'" class="w-full h-full object-cover">
            <i v-else class="fas fa-user text-3xl text-gray-400"></i>
          </div>
          <div class="flex justify-between items-start mb-6">
            <div>
              <h2 class="text-xl font-bold">{{ userInfo.name || '加载中...' }}</h2>
              <p class="text-xs text-gray-500">ID: {{ userInfo.id || '-' }}</p>
            </div>
            <div>
              <span :class="['text-[10px] px-2 py-1 rounded-full', 
                apiKeyStatus ? 'bg-green-500/20 text-green-500' : 'bg-red-500/20 text-red-500']">
                {{ apiKeyStatus ? '已配置' : '未配置' }}
              </span>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-3 mb-6">
            <div class="component-tertiary rounded-xl p-4 text-center">
              <div class="text-lg font-bold text-blue-500">{{ formatNumber(userInfo.score || 0) }}</div>
              <div class="text-xs text-gray-500">积分</div>
            </div>
            <div class="component-tertiary rounded-xl p-4 text-center">
              <div class="text-lg font-bold text-purple-500">{{ userInfo.creation_count || 0 }}</div>
              <div class="text-xs text-gray-500">创作</div>
            </div>
          </div>
          <button 
            @click="handleCheckin"
            :disabled="!userInfo.can_checkin"
            class="w-full py-3 bg-gradient-to-r from-green-500 to-teal-500 text-white font-bold rounded-xl mb-2 relative overflow-hidden"
            :class="{'opacity-50 cursor-not-allowed': !userInfo.can_checkin}">
            {{ userInfo.can_checkin ? '每日签到' : '今日已签到' }}
          </button>
          <div class="text-center text-xs text-gray-500 mb-4">签到次数: {{ userInfo.checkin_count || 0 }}</div>
          <div class="flex gap-3">
            <button @click="openApiKeyModal" class="flex-1 py-2 border border-blue-500/50 text-blue-500 rounded-lg text-xs">
              {{ apiKeyStatus ? '修改 Key' : '配置 Key' }}
            </button>
            <button v-if="apiKeyStatus" @click="deleteApiKey" class="flex-1 py-2 border border-red-500/50 text-red-500 rounded-lg text-xs">删除 Key</button>
          </div>
        </div>
      </div>
    </div>

    <!-- API Key 配置弹窗 -->
    <div v-if="showApiKeyModal" @click.self="closeApiKeyModal" class="fixed inset-0 z-[71] flex items-center justify-center">
      <div class="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
      <div class="relative component-bg w-full max-w-md mx-4 rounded-xl p-6 shadow-2xl" @click.stop>
        <h2 class="text-lg font-bold mb-4">配置 API Key</h2>
        <p class="text-xs text-gray-500 mb-3">积分用完后将使用KEY进行绘图</p>
        <input v-model="apiKeyInput" type="password" class="w-full component-tertiary rounded-lg px-4 py-3 text-sm mb-4" placeholder="sk-...">
        <input v-model="apiBaseUrlInput" type="text" class="w-full component-tertiary rounded-lg px-4 py-3 text-sm mb-4" value="https://api.fengjungpt.com">
        <div class="flex gap-3">
          <button @click="saveApiKey" class="flex-1 bg-blue-600 text-white py-2 rounded-lg">保存</button>
          <button @click="closeApiKeyModal" class="flex-1 component-tertiary py-2 rounded-lg">取消</button>
        </div>
      </div>
    </div>

    <!-- 教程弹窗 -->
    <div v-if="showTutorialModal" @click.self="closeTutorial" class="fixed inset-0 z-[80] flex items-center justify-center p-4">
      <div class="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
      <div class="relative w-full max-w-6xl max-h-[90vh] rounded-2xl shadow-2xl overflow-hidden bg-[#09090b] border border-white/10 flex flex-col animate-[fadeIn_0.3s_ease-out]">
        <button @click="closeTutorial" class="absolute top-4 right-4 z-50 w-8 h-8 rounded-full bg-black/50 text-white flex items-center justify-center border border-white/20 hover:bg-white/20 transition-colors cursor-pointer">
          <i class="fas fa-times"></i>
        </button>
        <div class="flex-1 overflow-y-auto">
          <Tutorial />
        </div>
      </div>
    </div>

    <!-- 公告弹窗 -->
    <div v-if="showNoticeModal" @click.self="closeNotice" class="fixed inset-0 z-[100] flex items-center justify-center p-6">
      <div class="absolute inset-0 bg-black/80 backdrop-blur-sm transition-opacity duration-300"></div>
      <div class="relative w-full max-w-lg component-bg rounded-[20px] border border-white/10 shadow-2xl transform transition-all scale-100 overflow-hidden animate-[fadeIn_0.3s_ease-out]">
        <button @click="closeNotice" class="absolute top-5 right-5 w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors z-20" style="color: var(--text-secondary);">
          <i class="fas fa-times text-lg"></i>
        </button>
        <div class="p-8">
          <div class="mb-6">
            <h3 class="text-2xl font-bold tracking-tight mb-2" style="color: var(--text-primary);">系统公告</h3>
            <p class="text-xs opacity-50 flex items-center gap-2 font-mono" style="color: var(--text-secondary);">
              <span>{{ noticeTime }}</span>
            </p>
          </div>
          <div class="text-base whitespace-pre-wrap scrollbar-none" style="background-color: transparent !important; border: none !important; padding: 0 !important; margin: 0 !important; box-shadow: none !important; min-height: 100px; max-height: 60vh; overflow-y: auto; line-height: 1.8; color: var(--text-primary) !important;">
            {{ noticeContent || '正在获取最新公告...' }}
          </div>
        </div>
        <div class="h-[2px] w-full bg-gradient-to-r from-blue-500/50 via-purple-500/50 to-pink-500/50 opacity-50"></div>
      </div>
    </div>

    <!-- 图片预览灯箱 -->
    <div v-if="showLightbox" @click="closeLightbox" id="my-native-lightbox" class="fixed inset-0 z-[2147483647] bg-black/92 backdrop-blur-sm flex flex-col items-center justify-center">
      <img :src="lightboxImage" alt="预览图片" class="max-w-[95vw] max-h-[95vh] object-contain rounded border border-white/20 shadow-2xl cursor-zoom-out">
      <div class="lightbox-tip text-gray-400 mt-4 text-sm">点击任意处关闭</div>
    </div>

    <!-- 充值中心弹窗 -->
    <div v-if="showRechargeModal" @click.self="closeRechargeCenter" class="fixed inset-0 z-[75] flex items-center justify-center p-4">
      <div class="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
      <div class="relative component-bg w-full max-w-lg mx-4 rounded-2xl shadow-2xl overflow-hidden" @click.stop>
        <button @click="closeRechargeCenter" class="absolute top-4 right-4 z-50 w-8 h-8 rounded-full bg-black/50 text-white flex items-center justify-center border border-white/20 hover:bg-white/20 transition-colors cursor-pointer">
          <i class="fas fa-times"></i>
        </button>
        
        <div class="p-8">
          <!-- 标题区域 -->
          <div class="text-center mb-8">
            <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-yellow-500/20 mb-4">
              <i class="fas fa-gem text-yellow-500 text-2xl"></i>
            </div>
            <h2 class="text-2xl font-bold mb-2">充值中心</h2>
            <p class="text-sm text-gray-400">微信支付・秒速到账・自动加积分</p>
          </div>

          <!-- 充值选项 -->
          <div class="space-y-4 mb-6">
            <!-- 选项1: 40积分 -->
            <div @click="selectRechargePlan(1)" :class="['recharge-option p-4 rounded-xl border-2 cursor-pointer transition-all', selectedPlan === 1 ? 'border-yellow-500 bg-yellow-500/10' : 'border-white/10 hover:border-yellow-500/50']">
              <div class="flex items-center justify-between">
                <div>
                  <div class="text-lg font-bold mb-1">40 积分</div>
                  <div class="text-xs text-gray-400">尝鲜体验・约0.25元/张</div>
                </div>
                <div class="text-right">
                  <div class="text-xl font-bold text-yellow-500">¥9.9</div>
                </div>
              </div>
            </div>

            <!-- 选项2: 120积分 (超值推荐) -->
            <div @click="selectRechargePlan(2)" :class="['recharge-option p-4 rounded-xl border-2 cursor-pointer transition-all relative', selectedPlan === 2 ? 'border-yellow-500 bg-yellow-500/10' : 'border-white/10 hover:border-yellow-500/50']">
              <div class="absolute -top-2 left-3 flex items-center gap-1 bg-blue-500 text-white text-[10px] px-2 py-1 rounded-full z-10">
                <i class="fas fa-thumbs-up"></i>
                <span>超值推荐</span>
              </div>
              <div class="flex items-center justify-between pt-1">
                <div>
                  <div class="text-lg font-bold mb-1">120 积分</div>
                  <div class="text-xs text-gray-400">赠送10积分・更划算</div>
                </div>
                <div class="text-right">
                  <div class="text-xl font-bold text-yellow-500">¥29.9</div>
                  <div class="text-xs text-gray-500 line-through">¥39.9</div>
                </div>
              </div>
            </div>

            <!-- 选项3: 500积分 (量大更省) -->
            <div @click="selectRechargePlan(3)" :class="['recharge-option p-4 rounded-xl border-2 cursor-pointer transition-all relative', selectedPlan === 3 ? 'border-yellow-500 bg-yellow-500/10' : 'border-white/10 hover:border-yellow-500/50']">
              <div class="absolute -top-2 left-3 bg-purple-500 text-white text-[10px] px-2 py-1 rounded-full z-10">
                量大更省
              </div>
              <div class="flex items-center justify-between pt-1">
                <div>
                  <div class="text-lg font-bold mb-1">500 积分</div>
                  <div class="text-xs text-gray-400">单价低至0.2元/张</div>
                </div>
                <div class="text-right">
                  <div class="text-xl font-bold text-yellow-500">¥99</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 说明文字 -->
          <div class="text-xs text-gray-400 mb-6 leading-relaxed">
            支付完成后自动到账；电脑端会在新窗口打开支付页，完成后可确认刷新积分。
          </div>

          <!-- 按钮 -->
          <div class="flex gap-3">
            <button @click="handleRecharge" :disabled="!selectedPlan" class="flex-1 py-3 bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-bold rounded-xl disabled:opacity-50 disabled:cursor-not-allowed transition-all">
              立即充值
            </button>
            <button @click="closeRechargeCenter" class="flex-1 py-3 component-tertiary text-gray-400 rounded-xl hover:text-white transition-all">
              暂不需要
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../utils/api'
import { openLoginModal } from '../utils/loginGate'
import { showSuccessToast, showErrorToast } from '../utils/toast'
import { fixImageUrl, formatNumber, debounce, downloadImage } from '../utils/helpers'
import Tutorial from './Tutorial.vue'

export default {
  name: 'Home',
  components: {
    Tutorial
  },
  data() {
    return {
      theme: localStorage.getItem('theme') || 'dark',
      activeTab: 'create',
      showMobileMenu: false,
      showUserMenu: false,
      showUserCenterModal: false,
      showApiKeyModal: false,
      showTutorialModal: false,
      showNoticeModal: false,
      showRechargeModal: false,
      showModelDropdown: false,
      showAdvanced: false,
      showLightbox: false,
      lightboxImage: '',
      currentView: 'inspiration',
      loading: false,
      selectedPlan: null,
      
      // 充值套餐配置
      rechargePlans: [
        { id: 1, points: 40, price: 9.9, desc: '尝鲜体验・约0.25元/张', originalPrice: null, tag: null },
        { id: 2, points: 120, price: 29.9, desc: '赠送10积分・更划算', originalPrice: 39.9, tag: { text: '超值推荐', color: 'blue' } },
        { id: 3, points: 500, price: 99, desc: '单价低至0.2元/张', originalPrice: null, tag: { text: '量大更省', color: 'purple' } }
      ],
      
      // 模型相关
      models: [
        { id: 'nano-banana', name: 'Nano Banana', icon: '🍌', description: '标准模式，生成速度快，适合日常使用' },
        { id: 'nano-banana-hd', name: 'Nano Banana HD', icon: '✨', description: '高清模式，增强画质细节' },
        { id: 'nano-banana-2', name: 'Nano Banana 2.0', icon: '🚀', description: '最新一代大模型，极致画质 (支持比例选择)' },
        { id: 'nano-banana-2-2k', name: 'Nano Banana 2.0 (2K)', icon: '🔷', description: '2K 模式，超清分辨率绘图' },
        { id: 'nano-banana-2-4k', name: 'Nano Banana 2.0 (4K)', icon: '💠', description: '4K 模式，极致细节视觉盛宴' }
      ],
      selectedModel: 'nano-banana',
      selectedQuantity: '1',
      aspectRatio: '1:1',
      
      // 图片相关
      uploadedImageFiles: [],
      prompt: '',
      charCount: 0,
      isGenerating: false,
      
      // 数据
      inspirations: [],
      myWorks: [],
      
      // 用户信息
      userInfo: {},
      apiKeyStatus: false,
      apiKeyInput: '',
      apiBaseUrlInput: 'https://api.fengjungpt.com',
      
      // 公告
      noticeContent: '',
      noticeTime: 'Loading...'
    }
  },
  computed: {
    selectedModelInfo() {
      return this.models.find(m => m.id === this.selectedModel) || this.models[0]
    },
    displayItems() {
      return this.currentView === 'inspiration' ? this.inspirations : this.myWorks
    }
  },
  mounted() {
    this.checkAuth()
    this.loadModels()
    this.initializeKeyboardShortcuts()
    this.setupImageLightbox()
  },
  methods: {
    checkAuth() {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token')
      if (!token) {
        openLoginModal()
        return
      }
      this.loadInspirations()
    },
    
    loadModels() {
      // 模型列表已在 data 中定义
    },
    
    selectModel(model) {
      this.selectedModel = model.id
      this.showModelDropdown = false
    },
    
    toggleModelDropdown() {
      this.showModelDropdown = !this.showModelDropdown
    },
    
    handleImageUpload() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.multiple = true
      input.onchange = (e) => {
        const newFiles = Array.from(e.target.files)
        if (newFiles.length === 0) return
        if (this.uploadedImageFiles.length + newFiles.length > 3) {
          showErrorToast('❌ 最多只能上传3张参考图片！')
          return
        }
        newFiles.forEach(file => {
          file._uploadId = Date.now() + '_' + Math.random().toString(36).substr(2, 9)
        })
        this.uploadedImageFiles = [...this.uploadedImageFiles, ...newFiles]
      }
      input.click()
    },
    
    getImagePreview(file) {
      return URL.createObjectURL(file)
    },
    
    removeUploadedImage(index) {
      this.uploadedImageFiles.splice(index, 1)
    },
    
    clearPrompt() {
      this.prompt = ''
      this.charCount = 0
    },
    
    updateCharCount() {
      this.charCount = this.prompt.length
    },
    
    toggleAdvanced() {
      this.showAdvanced = !this.showAdvanced
    },
    
    async handleGenerate() {
      if (this.isGenerating) {
        showErrorToast('正在生成中，请稍候...')
        return
      }
      
      if (!this.prompt.trim()) {
        showErrorToast('请输入图片描述')
        return
      }
      
      this.isGenerating = true
      this.switchToMyWorksTab()
      this.currentView = 'myworks'
      
      try {
        let result
        if (this.uploadedImageFiles.length > 0) {
          result = await this.editImage(this.prompt, this.uploadedImageFiles)
        } else {
          result = await this.generateImage(this.prompt)
        }
        
        if (result && result.success) {
          showSuccessToast(`生成成功！共生成 ${Array.isArray(result.data) ? result.data.length : 1} 张图片`)
          this.fetchMyWorks()
        } else {
          throw new Error(result.error || '生成失败')
        }
      } catch (error) {
        console.error('生成错误:', error)
        showErrorToast(error.message || '图片生成失败')
      } finally {
        this.isGenerating = false
      }
    },
    
    async generateImage(prompt) {
      const requestBody = {
        prompt,
        model: this.selectedModel,
        quantity: this.selectedQuantity
      }
      
      if (this.selectedModel.startsWith('nano-banana-2')) {
        const sizeMap = {
          '1:1': { w: 1024, h: 1024 },
          '16:9': { w: 1024, h: 576 },
          '9:16': { w: 576, h: 1024 },
          '4:3': { w: 1024, h: 768 },
          '3:4': { w: 768, h: 1024 },
          '21:9': { w: 1344, h: 576 }
        }
        const dims = sizeMap[this.aspectRatio] || sizeMap['1:1']
        requestBody.aspect_ratio = this.aspectRatio
        requestBody.width = dims.w
        requestBody.height = dims.h
        requestBody.size = `${dims.w}x${dims.h}`
      }
      
      return await api.post('/image/generate', requestBody)
    },
    
    async editImage(prompt, imageFiles) {
      const formData = new FormData()
      formData.append('prompt', prompt)
      
      if (Array.isArray(imageFiles)) {
        imageFiles.forEach(file => formData.append('image', file))
      } else {
        formData.append('image', imageFiles)
      }
      
      formData.append('model', this.selectedModel)
      formData.append('quantity', this.selectedQuantity)
      
      if (this.selectedModel.startsWith('nano-banana-2')) {
        const sizeMap = {
          '1:1': { w: 1024, h: 1024 },
          '16:9': { w: 1024, h: 576 },
          '9:16': { w: 576, h: 1024 },
          '4:3': { w: 1024, h: 768 },
          '3:4': { w: 768, h: 1024 },
          '21:9': { w: 1344, h: 576 }
        }
        const dims = sizeMap[this.aspectRatio] || sizeMap['1:1']
        formData.append('aspect_ratio', this.aspectRatio)
        formData.append('width', dims.w)
        formData.append('height', dims.h)
        formData.append('size', `${dims.w}x${dims.h}`)
      }
      
      return await api.post('/image/edit', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    },
    
    switchToCreate() {
      this.activeTab = 'create'
      this.closeMobileMenu()
    },
    
    switchToInspire() {
      this.activeTab = 'inspire'
      this.closeMobileMenu()
      if (this.currentView === 'myworks') {
        this.switchToMyWorksTab()
      } else {
        this.switchToInspirationTab()
      }
    },
    
    switchToInspirationTab() {
      this.currentView = 'inspiration'
      this.loadInspirations()
    },
    
    switchToMyWorksTab() {
      this.currentView = 'myworks'
      this.fetchMyWorks()
    },
    
    async loadInspirations() {
      this.loading = true
      try {
        const res = await api.get('/image/inspirations')
        if (res.success && res.data) {
          this.inspirations = res.data
        }
      } catch (error) {
        console.error('加载灵感失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    async fetchMyWorks() {
      this.loading = true
      try {
        const res = await api.get(`/image/history?t=${new Date().getTime()}`)
        if (res.success && res.data) {
          this.myWorks = res.data
        }
      } catch (error) {
        console.error('加载作品失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    handleItemClick(item) {
      if (this.currentView === 'inspiration') {
        this.prompt = item.prompt
        this.switchToCreate()
        showSuccessToast('✨ 提示词已应用')
      }
    },
    
    getAspectRatioStyle(item) {
      if (item.size) {
        const [width, height] = item.size.split('x').map(Number)
        if (width && height) {
          return `aspect-ratio: ${width / height};`
        }
      }
      return ''
    },
    
    async useAsReference(imgUrl) {
      if (this.uploadedImageFiles.length >= 3) {
        showErrorToast('参考图已满 3 张，请先删除旧图')
        return
      }
      
      try {
        showSuccessToast('正在获取图片资源...')
        const response = await fetch(imgUrl)
        if (!response.ok) throw new Error('图片下载失败')
        const blob = await response.blob()
        const fileName = `ref_${Date.now()}.png`
        const file = new File([blob], fileName, { type: blob.type })
        file._uploadId = Date.now() + '_' + Math.random().toString(36).substr(2, 9)
        this.uploadedImageFiles = [...this.uploadedImageFiles, file]
        showSuccessToast('✨ 已设为参考图，可继续修改提示词')
        if (window.innerWidth < 1024) {
          this.switchToCreate()
        }
      } catch (error) {
        console.error('垫图失败:', error)
        showErrorToast('无法获取该图片 (可能是跨域限制)')
      }
    },
    
    async deleteImage(id) {
      if (!confirm('确定删除这张图片吗?')) return
      try {
        const res = await api.delete(`/image/delete/${id}`)
        if (res.success || res.code === 200) {
          showSuccessToast('✅ 图片已删除')
          this.fetchMyWorks()
        } else {
          throw new Error(res.error || '删除失败')
        }
      } catch (error) {
        console.error('删除出错:', error)
        showErrorToast('❌ 删除失败: ' + (error.message || '网络错误'))
      }
    },
    
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
    
    closeMobileMenu() {
      this.showMobileMenu = false
    },
    
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
    },
    
    openUserCenter() {
      this.showUserCenterModal = true
      this.showUserMenu = false
      this.fetchUserInfo()
    },
    
    closeUserCenter() {
      this.showUserCenterModal = false
    },
    
    async fetchUserInfo() {
      // 先检查 token 是否存在
      const token = localStorage.getItem('token') || sessionStorage.getItem('token')
      if (!token) {
        console.warn('未找到 token，跳过获取用户信息')
        return
      }
      
      try {
        // 在请求前再次确认 token
        const currentToken = localStorage.getItem('token') || sessionStorage.getItem('token')
        console.log('获取用户信息 - token 存在:', !!currentToken, currentToken ? currentToken.substring(0, 20) + '...' : '无')
        console.log('完整 token:', currentToken)
        
        if (!currentToken) {
          console.error('未找到 token，无法获取用户信息')
          return
        }
        
        // 只尝试 /user 接口（/api/user 返回 404）
        const res = await api.get('/user')
        console.log('用户信息响应:', res)
        
        // 根据接口返回的数据结构：res.data.user
        if (res && res.data && res.data.user) {
          this.userInfo = {
            headimg: res.data.user.headimg,
            name: res.data.user.name,
            score: res.data.user.score,
            id: res.data.user.id,
            // 保留其他可能的字段
            ...res.data.user
          }
          console.log('用户信息已更新:', this.userInfo)
          await this.fetchUserApiKey()
        } else {
          console.warn('用户信息数据格式不正确:', res)
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        console.error('错误详情:', {
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          message: error.message,
          headers: error.response?.headers
        })
        
        // 如果返回 401，检查错误信息
        if (error.response && error.response.status === 401) {
          const errorData = error.response.data || error.response
          console.error('401 错误详情:', errorData)
          
          // 如果错误信息是"需要登录认证"，可能是 token 格式不对或已过期
          if (errorData.message && errorData.message.includes('需要登录')) {
            console.warn('Token 可能无效或已过期，建议重新登录')
            // 不显示错误提示，静默失败
          }
        }
        
        // 只有在明确的 401 错误且确实有 token 时才认为是认证失败
        if (error.response && error.response.status === 401) {
          const token = localStorage.getItem('token') || sessionStorage.getItem('token')
          if (token) {
            // 有 token 但返回 401，可能是 token 过期或无效
            // 但不要立即跳转，先尝试其他方式
            console.warn('获取用户信息返回 401，但 token 存在，可能是接口问题或 token 格式不对')
            // 不显示错误提示，静默失败，让用户继续使用
            // 如果真的是 token 过期，其他接口调用时也会失败，那时再跳转
            return
          }
        }
        // 其他错误也不显示提示，避免干扰用户体验
        // 静默失败，不影响用户继续使用
      }
    },
    
    async fetchUserApiKey() {
      try {
        const res = await api.get('/user/api-keys')
        this.apiKeyStatus = res.success && res.has_key
      } catch (error) {
        console.error('获取 API Key 失败:', error)
      }
    },
    
    async handleCheckin() {
      if (!this.userInfo.can_checkin) return
      try {
        const res = await api.post('/user/checkin')
        if (res.success) {
          showSuccessToast(`签到成功！获得 ${res.data.points_earned} 积分`)
          this.fetchUserInfo()
        } else {
          showErrorToast(res.error || '签到失败')
        }
      } catch (error) {
        console.error('签到错误:', error)
        showErrorToast('签到失败')
      }
    },
    
    openApiKeyModal() {
      this.showApiKeyModal = true
    },
    
    closeApiKeyModal() {
      this.showApiKeyModal = false
      this.apiKeyInput = ''
    },
    
    async saveApiKey() {
      if (!this.apiKeyInput.trim()) return
      try {
        const res = await api.post('/user/api-keys', {
          api_key: this.apiKeyInput,
          api_base_url: this.apiBaseUrlInput
        })
        if (res.success) {
          showSuccessToast('保存成功')
          this.closeApiKeyModal()
          this.fetchUserApiKey()
        } else {
          showErrorToast(res.error || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        showErrorToast('保存失败')
      }
    },
    
    async deleteApiKey() {
      if (!confirm('确定删除配置的 Key 吗？')) return
      try {
        const res = await api.delete('/user/api-keys')
        if (res.success || res.code === 200) {
          showSuccessToast('已删除')
          this.fetchUserApiKey()
        }
      } catch (error) {
        console.error('删除失败:', error)
      }
    },
    
    handleLogout() {
      if (confirm('确定退出吗？')) {
        localStorage.clear()
        sessionStorage.clear()
        openLoginModal()
      }
    },
    
    showTutorial() {
      this.showTutorialModal = true
    },
    
    closeTutorial() {
      this.showTutorialModal = false
    },
    
    showRechargeCenter() {
      this.showRechargeModal = true
      this.selectedPlan = null
    },
    
    closeRechargeCenter() {
      this.showRechargeModal = false
      this.selectedPlan = null
    },
    
    selectRechargePlan(planId) {
      this.selectedPlan = planId
    },
    
    async handleRecharge() {
      if (!this.selectedPlan) {
        showErrorToast('请选择充值套餐')
        return
      }
      
      const plan = this.rechargePlans.find(p => p.id === this.selectedPlan)
      if (!plan) return
      
      try {
        const res = await api.post('/user/recharge', {
          plan_id: plan.id,
          points: plan.points,
          amount: plan.price
        })
        
        if (res.success && res.data && res.data.payment_url) {
          const paymentWindow = window.open(res.data.payment_url, '_blank')
          
          if (paymentWindow) {
            showSuccessToast('正在跳转到支付页面...')
            if (res.data.order_id) {
              this.checkPaymentStatus(res.data.order_id)
            }
          } else {
            showErrorToast('无法打开支付页面，请检查浏览器弹窗设置')
          }
        } else {
          showErrorToast(res.error || '创建订单失败')
        }
      } catch (error) {
        console.error('充值错误:', error)
        showErrorToast('充值失败，请稍后重试')
      }
    },
    
    async checkPaymentStatus(orderId) {
      const maxAttempts = 60
      let attempts = 0
      
      const checkInterval = setInterval(async () => {
        attempts++
        
        try {
          const res = await api.get(`/user/recharge/status/${orderId}`)
          if (res.success && res.data && res.data.status === 'paid') {
            clearInterval(checkInterval)
            showSuccessToast('充值成功！积分已到账')
            this.closeRechargeCenter()
            this.fetchUserInfo()
          } else if (attempts >= maxAttempts) {
            clearInterval(checkInterval)
            showErrorToast('支付超时，请手动刷新积分')
          }
        } catch (error) {
          console.error('检查支付状态失败:', error)
          if (attempts >= maxAttempts) {
            clearInterval(checkInterval)
          }
        }
      }, 5000)
    },
    
    showNotification() {
      this.showNoticeModal = true
      this.fetchAnnouncement()
    },
    
    closeNotice() {
      this.showNoticeModal = false
    },
    
    async fetchAnnouncement() {
      try {
        const res = await api.get('/image/public/announcement')
        if (res.success && res.data) {
          this.noticeContent = res.data.content
          this.noticeTime = '发布于: ' + new Date(res.data.createdAt).toLocaleString()
        } else {
          this.noticeContent = '暂时没有新的系统公告。'
          this.noticeTime = ''
        }
      } catch (error) {
        console.error('获取公告失败', error)
        this.noticeContent = '加载公告失败，请稍后重试。'
      }
    },
    
    toggleTheme() {
      this.theme = this.theme === 'light' ? 'dark' : 'light'
      localStorage.setItem('theme', this.theme)
      document.body.setAttribute('data-theme', this.theme)
    },
    
    initializeKeyboardShortcuts() {
      document.addEventListener('keydown', (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
          e.preventDefault()
          if (!this.isGenerating) {
            this.handleGenerate()
          }
        }
      })
    },
    
    setupImageLightbox() {
      document.addEventListener('click', (e) => {
        const target = e.target
        if (target.tagName !== 'IMG') return
        if (target.closest('[data-prompt]')) return
        if (target.id === 'lightbox-img') return
        if (target.naturalWidth < 50 || target.naturalHeight < 50) return
        
        e.preventDefault()
        e.stopPropagation()
        this.lightboxImage = target.src
        this.showLightbox = true
      })
    },
    
    closeLightbox() {
      this.showLightbox = false
      this.lightboxImage = ''
    },
    
    fixImageUrl,
    formatNumber,
    downloadImage
  }
}
</script>

<style>
/* Home 页面特定样式 - 非 scoped 以支持全局类名 */

.masonry-grid {
  column-count: 3;
  column-gap: 1rem;
}

.masonry-item {
  break-inside: avoid;
  margin-bottom: 1rem;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.2s;
  min-height: 100px;
}

.masonry-item:hover {
  transform: translateY(-5px);
  border-color: var(--accent-blue);
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

#my-native-lightbox {
  display: flex;
  position: fixed;
  z-index: 2147483647;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.92);
  justify-content: center;
  align-items: center;
  flex-direction: column;
  backdrop-filter: blur(5px);
  transition: opacity 0.3s;
}

.lightbox-tip {
  color: #aaa;
  margin-top: 15px;
  font-size: 14px;
  font-family: sans-serif;
  pointer-events: none;
}

@media (max-width: 1024px) {
  .masonry-grid {
    column-count: 2;
  }
  
  .control-panel {
    height: 100% !important;
    border-bottom: none !important;
    padding-top: 0px !important;
    display: flex;
    flex-direction: column;
  }
  
  .control-panel {
    justify-content: space-between !important;
  }
  
  .control-panel > div:first-child {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }
  
  .mobile-header-container {
    display: none !important;
  }
}

@media (max-width: 480px) {
  .masonry-grid {
    column-count: 2;
    column-gap: 0.5rem;
  }
  
  .masonry-item .p-3 {
    padding: 0.5rem !important;
  }
  
  .masonry-item p {
    font-size: 10px !important;
  }
}

/* 充值选项样式 */
.recharge-option {
  background: var(--bg-tertiary);
  transition: all 0.3s ease;
  position: relative;
  overflow: visible;
}

.recharge-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(251, 191, 36, 0.2);
}

.recharge-option .absolute {
  white-space: nowrap;
}
</style>

